import React from 'react';
import './ripple.css'

const Ripple = () => {
  return (
    <div className='lds-ripple'>
      <div></div>
      <div></div>
    </div>
  );
};

export default Ripple;
